import React from 'react';
import { MatchIndicator } from '../MatchIndicator';
import type { Job } from '../../../types/job';

interface JobHeaderProps {
  job: Job;
  matchPercentage: number;
}

export function JobHeader({ job, matchPercentage }: JobHeaderProps) {
  return (
    <div className="flex items-start space-x-4 mb-6">
      <img
        src={job.logo}
        alt={`${job.company} logo`}
        className="w-16 h-16 rounded-lg object-cover"
      />
      <div>
        <h1 className="text-2xl font-bold text-black">
          {job.title}
        </h1>
        <p className="text-black">{job.company}</p>
        <div className="mt-2 space-x-4">
          <span className="text-black">{job.location}</span>
          <span className="text-black">{job.type}</span>
          <span className="text-black">{job.salary}</span>
        </div>
        {matchPercentage > 0 && (
          <div className="mt-2">
            <MatchIndicator percentage={matchPercentage} />
          </div>
        )}
      </div>
    </div>
  );
}